import { gql } from "@apollo/client";

export const FOLDER_GENERAL_INFO_UPDATED = gql`
  subscription FolderGeneralInfoUpdated($documentId: Int!, $siteId: Int!) {
    folderGeneralInfoUpdated(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
    }
  }
`;

export const NEW_FOLDER_SAVED = gql`
  subscription NewFolderSaved {
    newFolderSaved {
      documentId
      siteId
    }
  }
`;

export const CALCULATE_APPROVAL_TASK_GENERATED = gql`
  subscription CalculateApprovalTaskGenerated($documentId: Int!, $siteId: Int!) {
    calculateApprovalTaskGenerated(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      documentTypeCode
      offerNo
    }
  }
`;

export const FOLDER_RESPONSIBLE_UPDATED = gql`
  subscription FolderResponsibleUpdated($documentId: Int!, $siteId: Int!) {
    folderResponsibleUpdated(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      responsibleId
      responsibleName
    }
  }
`;
